import { BookingMailTemplate } from '@/helpers/fs/bookingMailTemplate'
import { isEmpty, isNull } from 'es-toolkit/compat'
import { defineStore } from 'pinia'
import { useTeamStore } from './teamStore'

type State = {
  templates: BookingMailTemplate[]
  isLoading: boolean
}

/**
 * 予約者向けプレートの一覧取得用Store。
 * formsStore のパターンをミラーしている。
 */
export const useBookingMailTemplatesStore = defineStore(
  'bookingMailTemplates',
  {
    state: (): State => {
      return {
        templates: [],
        isLoading: true
      }
    },
    actions: {
      async setup() {
        // 既に取得済みなら二重フェッチしない（App.vue と BookingMailTemplateSelect の両方から呼ばれるため）
        if (this.templates.length > 0 && !this.isLoading) return
        await this.reload()
      },
      async reload() {
        const currentTeamId = useTeamStore().currentTeamId
        if (isNull(currentTeamId)) {
          // チーム未所属の場合はローディングを解除してガード側UIに委ねる
          this.isLoading = false
          return
        }
        this.templates = await BookingMailTemplate.builds(currentTeamId)
        this.isLoading = false
      }
    },
    getters: {
      hasNoTemplate(state): boolean {
        return !state.isLoading && isEmpty(state.templates)
      }
    }
  }
)
